import FileUpload from '../FileUpload';
import SearchSelect from '../ui/SearchSelect';
import { useTranslation } from 'react-i18next';

function AnalyseForm({
    onSubmit,
    uploading,
    error,
    success,
    useProfileCV,
    setUseProfileCV,
    permanentCV,
    selectedAppId,
    setSelectedAppId,
    jobDescription,
    setJobDescription,
    applications,
}) {
    const { t } = useTranslation();

    const appOptions = applications.map(app => ({
        value: String(app.id),
        label: `${app.position} at ${app.company_name}`,
    }));

    return (
        <div className="card">
            <h2>{t('resume.analyse_title')}</h2>
            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            <form onSubmit={onSubmit}>
                <div className="form-group">
                    <label>{t('resume.which_cv')}</label>
                    <div className="cv-choice">
                        <label className={`cv-option ${!useProfileCV ? 'selected' : ''}`}>
                            <input
                                type="radio"
                                name="cv_source"
                                checked={!useProfileCV}
                                onChange={() => setUseProfileCV(false)}
                            />
                            {t('resume.upload_new')}
                        </label>
                        <label className={`cv-option ${useProfileCV ? 'selected' : ''}`}>
                            <input
                                type="radio"
                                name="cv_source"
                                checked={useProfileCV}
                                onChange={() => setUseProfileCV(true)}
                            />
                            {t('resume.use_profile')}
                            {permanentCV && (
                                <span className="cv-name"> — {permanentCV.file_name}</span>
                            )}
                            {!permanentCV && (
                                <span className="cv-missing"> ({t('resume.none_uploaded')})</span>
                            )}
                        </label>
                    </div>
                </div>

                {!useProfileCV && (
                    <div className="form-group">
                        <label>{t('resume.select_file')}</label>
                        <FileUpload name="resume" accept=".pdf,.docx" />
                    </div>
                )}

                <div className="form-group">
                    <label>{t('resume.link_application')}</label>
                    {applications.length === 0 ? (
                        <small className="hint">
                            {t('resume.no_apps')} <a href="/internships">{t('resume.add_one')}</a>
                        </small>
                    ) : (
                        <SearchSelect
                            options={appOptions}
                            value={selectedAppId}
                            onChange={setSelectedAppId}
                            placeholder={t('resume.search_select_application')}
                        />
                    )}
                </div>

                <div className="form-group">
                    <label>{t('resume.paste_jd')}</label>
                    <textarea
                        value={jobDescription}
                        onChange={e => setJobDescription(e.target.value)}
                        placeholder={t('resume.paste_placeholder')}
                        rows={6}
                    />
                </div>

                <button type="submit" disabled={uploading} className="btn-primary">
                    {uploading ? t('resume.analysing') : `🔍 ${t('resume.analyse_btn')}`}
                </button>
            </form>
        </div>
    );
}

export default AnalyseForm;